import React from "react";
import "./CHILD_DENTISTRY.css";
import Teeth_Whiting_img from "../images/dentist-2264144_1920.jpg";
export default function CHILD_DENTISTRY() {
  return (
    <div className="container_Child_Den">
      <h1>Child Dentistry</h1>
      <div className="img_box_Child_Den">
        <img src={Teeth_Whiting_img} className="img_of_Child_Den" alt="" />
      </div>
      <div className="text_main_Child_Den">
        <p>
          Child dentistry is a treatment of oral medical issues with children
          right from birth to adolescence. We take care of kids' teeth and gums
          as they change all through adolescence. We give thorough
          consideration, from precaution treatment like cleanings and sealants
          to treatment for oral sickness and wounds. We always advise guardians
          about a youngster's dietary and dental hygiene.
        </p>
        <h1>DID YOU KNOW??</h1>
        <p>
          Crumbling and decaying of the tooth is the most common amongst the
          kids. It is significantly more predominant than other normal youth
          diseases, for example, asthma. Besides, tooth rot and gum illness
          advances to a lifetime of oral difficulties.
        </p>
        <div className="FAQ_Service_Child_Den">
          <h2>FAQ'S</h2>
        </div>
      </div>
    </div>
  );
}
